export default __webpack_public_path__ + "assets/privacy-policy.03805805.pdf";